import { render, staticRenderFns } from "./RidesPerSalesChannel.vue?vue&type=template&id=57e3b19e&scoped=true&"
import script from "./RidesPerSalesChannel.vue?vue&type=script&lang=js&"
export * from "./RidesPerSalesChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e3b19e",
  null
  
)

export default component.exports